import React from "react";
import Logo from "../../components/Logo/Logo";
import Notifications from "../StatefulComponents/Notifications/Notifications";
import UserAccountButton from "../StatefulComponents/UserAccountButton/UserAccountButton";
import Styles from "./Header.scss";

/**
 * Renders the default app header
 */
export const AppHeader = () => {
    return (
        <div className={Styles.Container}>
            <div className={Styles.LogoWrapper}>
                <Logo type="with-text-right" />
            </div>
            <div className={Styles.HeaderActions}>
                {/* <div className={Styles.Notifications}>
                    <Notifications />
                </div> */}
                <div className={Styles.UserAccountBtn}>
                    <UserAccountButton />
                </div>
            </div>
        </div>
    );
};

export default AppHeader;
